import * as Types from '@aeppic/types'

export type DocumentIdentifier = Types.IdOrReference | Types.Document | { id: Types.DocumentId }

export function readId(identifer: DocumentIdentifier): string {
  if (typeof identifer === 'string') {
    return identifer
  } else {
    return identifer.id
  }
}
